<div class="menu-container">
  <div class="dealer-container">
    @for (dealer of dealers; track dealer.id) {
      <div class="mt-2 md:mt-4">
        <div *ngIf="dealer.active">
          <app-menu-card
            class="hidden md:block"
            [table]="dealer"
            [mainDealer]="dealers[0]"
          ></app-menu-card>
          <app-menu-card-landscape
            class="block w-full md:hidden"
            [table]="dealer"
            [mainDealer]="dealers[0]"
          ></app-menu-card-landscape>
        </div>

        <div *ngIf="!dealer.active">
          <app-menu-card-deactivated
            class="hidden md:block"
            [table]="dealer"
            [mainDealer]="dealers[0]"
          ></app-menu-card-deactivated>

          <app-menu-card-landscape-deactivated
            class="block w-full md:hidden"
            [table]="dealer"
            [mainDealer]="dealers[0]"
          ></app-menu-card-landscape-deactivated>
        </div>
      </div>
    }
  </div>
</div>
